import React from 'react';
import { Button } from '../ui/Button';
export const Services = () => {
  const services = [{
    subtitle: 'Product',
    title: 'Vision & AI Strategy',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80',
    items: ['AI-driven user research & competitive intelligence', 'Product vision development', 'Market opportunity analysis', 'AI integration strategy', 'Value proposition definition'],
    gradient: 'from-amber-400 via-orange-500 to-amber-300',
    link: '/services/strategy'
  }, {
    subtitle: 'Product',
    title: 'Experimentation & Rapid Prototyping',
    image: 'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80',
    items: ['Prototype creation & user testing', 'Feature prioritization', 'AI-powered A/B testing', 'Rapid iteration cycles', 'Hypothesis validation'],
    gradient: 'from-blue-600 via-indigo-500 to-purple-500',
    link: '/services/planning'
  }, {
    subtitle: 'Product',
    title: 'Execution & Delivery',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80',
    items: ['Automated backlog triage using machine learning', 'AI-enhanced PRD development', 'Development coordination', 'Quality assurance oversight', 'Continuous integration planning'],
    gradient: 'from-green-500 via-teal-500 to-cyan-500',
    link: '/services/development'
  }, {
    subtitle: 'Product',
    title: 'Market Launch & Growth',
    image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80',
    items: ['AI-powered user segmentation', 'Launch planning & execution', 'Growth experimentation', 'User onboarding optimization', 'Performance analytics & insights'],
    gradient: 'from-orange-500 via-red-500 to-pink-500',
    link: '/services/launch'
  }];
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="services" className="py-20 bg-white relative overflow-hidden" data-id="element-743">
      {/* Background pattern elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-purple-50 rounded-full opacity-50 -ml-36 -mt-36" data-id="element-744"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-50 rounded-full opacity-40 -mr-40 -mb-40" data-id="element-745"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-746">
        <div className="text-center mb-16" data-id="element-747">
          <h2 className="text-3xl md:text-5xl font-bold mb-2 text-black max-w-4xl mx-auto leading-tight" data-id="element-748">
            Every type of product work you'll
            <br data-id="element-749" />
            ever need, <span className="italic font-serif" data-id="element-750">and more</span>
          </h2>
        </div>
        {/* Grid layout instead of carousel */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-751">
          {services.map((service, index) => <div key={index} className={`relative h-[500px] rounded-3xl overflow-hidden bg-gradient-to-br ${service.gradient} shadow-lg transform transition-transform hover:scale-105`} data-id="element-752">
              <div className="absolute inset-0 bg-black/10" data-id="element-753"></div>
              <div className="absolute inset-0 flex flex-col justify-center items-center p-8" data-id="element-754">
                <div className="bg-black/70 backdrop-blur-sm rounded-2xl p-6 w-[85%] shadow-xl" data-id="element-755">
                  <a href={service.link} className="block text-4xl font-bold text-white mb-6 hover:text-primary-light transition-colors" data-id="element-756">
                    {service.title}
                  </a>
                  <ul className="space-y-2" data-id="element-757">
                    {service.items.map((item, idx) => <li key={idx} className="text-white/90 flex items-start" data-id="element-758">
                        <span className="mr-2" data-id="element-759">•</span>
                        <span data-id="element-760">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-12" data-id="element-761">
          <Button variant="primary" onClick={openCalendly} className="text-lg" data-id="element-762">
            Speak with a Senior PM
          </Button>
        </div>
      </div>
    </section>;
};